<template lang="">
  <div v-if="propPayoutDetails">
    <UploadDocs :propViewMode="true" :propDocsList="propPayoutDetails.payout_tid_img" :propUploadInputLabel="`Uploaded Payment Screenshots`" :propAllowedExtensions="`application/pdf`" />
    <h4 class="mt-4">Banking Transaction Id: <span class="primary-color">{{propPayoutDetails.payout_tid}}</span></h4>
    <h4 class="mt-4">Amount Paid(INR) <span class="primary-color">{{propPayoutDetails.payout_amount}}</span></h4>
  </div>
</template>
<script>
import UploadDocs from "../../../../components/UploadDocs.vue"

export default {
  name: "PayoutDetailsView",
  mounted () {
    console.log("propPayoutDetails ", this.propPayoutDetails)
  },
  props: {
    propPayoutDetails: {
      type: Object,
      default: null
    }
  },
  components: {
    UploadDocs
  }
}
</script>
<style lang="">

</style>
